// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-controls{width:inherit;display:flex;justify-content:space-between}.report-controls .row{flex:1;align-content:flex-start}.report-controls__wrapper{width:100%}.report-controls__overflow-menu{display:flex}", ""]);
// Exports
module.exports = exports;
